import appSettings from 'config/application/app-settings';

export function getPublicKey() {
  return appSettings.recaptchaPublicKey || null;
}

export function init() {
  return new Promise((resolve, reject) => {
    const recaptchaPublicKey = getPublicKey();

    if (recaptchaPublicKey && !window.grecaptcha) {
      const script = document.createElement('script');
      let done = false;

      script.onload = script.onreadystatechange = function callback() {
        if (
          !done &&
          (!script.readyState ||
            script.readyState === 'loaded' ||
            script.readyState === 'complete')
        ) {
          done = true;

          // Handle memory leak in IE
          script.onload = script.onreadystatechange = null;
          resolve(recaptchaPublicKey);
        }
      };

      script.onerror = reject;

      script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaPublicKey}`;
      document.head.appendChild(script);
    }

    if (!recaptchaPublicKey && !window.grecaptcha) {
      window.grecaptcha = {
        execute: () => Promise.resolve(),
        getResponse() {
          return 'recaptcha';
        }
      };
    }

    resolve(recaptchaPublicKey);
  });
}
